module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/male-3-fb53255f421f04bddd84f2c17d82b356.jpg";